import { render, staticRenderFns } from "./courseNum.vue?vue&type=template&id=24a89133&"
import script from "./courseNum.vue?vue&type=script&lang=js&"
export * from "./courseNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports